import type {
  ParsedAddress,
  PlaceAddressComponent,
  PlaceAddressSource,
} from './places.types.ts';

const findComponent = (
  components: readonly PlaceAddressComponent[],
  type: string,
) => components.find((component) => component.types.includes(type));

export const parsePlaceAddress = (place: PlaceAddressSource): ParsedAddress => {
  const components = place.addressComponents ?? [];
  const long = (type: string) =>
    findComponent(components, type)?.longText ?? '';
  const short = (type: string) =>
    findComponent(components, type)?.shortText ?? '';

  return {
    placeId: place.id ?? '',
    formattedAddress: place.formattedAddress ?? '',
    street: long('route'),
    streetNumber: long('street_number'),
    postalCode: long('postal_code'),
    city: long('administrative_area_level_3') || long('locality'),
    provinceCode: short('administrative_area_level_2'),
    region: long('administrative_area_level_1'),
    countryCode: short('country'),
  };
};
